module.exports = __webpack_public_path__ + "img/end-task.1ba497cd.svg";